import { render, staticRenderFns } from "./AlertMessageTopBar.vue?vue&type=template&id=498a5e96&scoped=true"
import script from "./AlertMessageTopBar.vue?vue&type=script&lang=js"
export * from "./AlertMessageTopBar.vue?vue&type=script&lang=js"
import style0 from "./AlertMessageTopBar.vue?vue&type=style&index=0&id=498a5e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498a5e96",
  null
  
)

export default component.exports